import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { BOOKING_URL } from './constants';
export function FinalCTA() {
  return <section className="relative py-32 overflow-hidden" data-id="element-55">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-56">
        <img src="https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?auto=format&fit=crop&q=80&w=2000" alt="Clínica estética" className="w-full h-full object-cover" data-id="element-57" />
        <div className="absolute inset-0 bg-black-premium/70 backdrop-blur-sm" data-id="element-58" />
      </div>

      <div className="container mx-auto px-6 md:px-12 relative z-10 text-center" data-id="element-59">
        <FadeIn data-id="element-60">
          <div className="inline-flex items-center gap-3 mb-8" data-id="element-61">
            <div className="h-[1px] w-12 bg-gold/50" data-id="element-62"></div>
            <span className="text-gold tracking-[0.2em] uppercase text-sm font-medium" data-id="element-63">
              Da el primer paso
            </span>
            <div className="h-[1px] w-12 bg-gold/50" data-id="element-64"></div>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-65">
          <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl text-white mb-8" data-id="element-66">
            Tu mejor versión{' '}
            <span className="text-gold italic" data-id="element-67">comienza hoy</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-68">
          <p className="text-white/80 text-lg md:text-xl max-w-2xl mx-auto font-light mb-12" data-id="element-69">
            Agenda tu valoración médica y descubre el plan de tratamiento ideal
            para resaltar tu belleza natural.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-70">
          <Button href={BOOKING_URL} target="_blank" rel="noopener noreferrer" size="lg" className="shadow-gold" data-id="element-71">
            Reservar consulta
          </Button>
        </FadeIn>
      </div>
    </section>;
}